module.exports = __webpack_public_path__ + "static/design-solid.47d8dd61.svg";